import { Stack } from '@mui/material';
import Typography from '../../../components/Typography';
import { ReactNode } from 'react';
import CopyIcon from '../../../icons/CopyIcon';

export interface CopyToLectureIntroductionProps {
  message: ReactNode;
  className?: string;
}

const CopyToLectureIntroductionLayout = ({ message, className }: CopyToLectureIntroductionProps) => {
  return (
    <Stack justifyContent="center" alignItems="center" height="100%" className={className}>
      <Stack alignItems="center" gap={4} overflow="hidden">
        <CopyIcon size={48} color="grey.300" />
        {typeof message === 'string' ? (
          <Typography variant="h6Medium" component="p" textAlign="center">
            {message}
          </Typography>
        ) : (
          message
        )}
      </Stack>
    </Stack>
  );
};

export default CopyToLectureIntroductionLayout;
